import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerSearchRequestV2WithoutBriefId,
  ISearchFacets,
} from "@shared/lib/types/briefInfluencerV2";
import { ColumnFilterWrapper } from "@shared/ui/filters/ColumnFilterWrapper";
import { Select } from "antd";
import { useState } from "react";

interface BriefPocFilterProps {
  title?: string;
  filters:
    | IBriefInfluencerSearchRequestV2
    | IBriefInfluencerSearchRequestV2WithoutBriefId;
  setFilters:
    | React.Dispatch<React.SetStateAction<IBriefInfluencerSearchRequestV2>>
    | React.Dispatch<
        React.SetStateAction<IBriefInfluencerSearchRequestV2WithoutBriefId>
      >;
  confirm: () => void;
  close: () => void;
  pocOptions: ISearchFacets["assignedPricingPocV2"];
  filterCount?: number;
}

export function BriefPocFilter({
  title = "Pricing POC",
  filters,
  setFilters,
  confirm,
  close,
  pocOptions,
  filterCount,
}: BriefPocFilterProps) {
  const [pocSelectedOption, setPocSelectedOption] = useState<string[]>(
    filters.assignedPricingPocV2 || []
  );

  const handlePocChange = (value: string[]) => {
    setPocSelectedOption(value);
  };

  const handleConfirm = () => {
    setFilters({
      ...(filters as any),
      assignedPricingPocV2: pocSelectedOption,
    });
    confirm();
  };

  const handleResetInternal = () => {
    setPocSelectedOption([]);
    setFilters({
      ...(filters as any),
      assignedPricingPocV2: [],
    });
    confirm();
  };

  const assignPocs = pocOptions?.map((poc) => ({
    label: `${poc.user.firstName} ${poc.user.lastName}`,
    value: poc._id,
  }));

  const isFiltered = pocSelectedOption.length > 0;

  return (
    <ColumnFilterWrapper
      title={title}
      filterCount={filterCount ?? pocSelectedOption.length}
      isFiltered={isFiltered}
      confirm={confirm}
      close={close}
      onApply={handleConfirm}
      onReset={handleResetInternal}
    >
      <div style={{ padding: "4px 0" }}>
        <p style={{ margin: "0 0 4px 0", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9ba3b2" }}>
          POC
        </p>
        <Select
          options={assignPocs}
          value={pocSelectedOption}
          onChange={handlePocChange}
          mode="multiple"
          placeholder="Select Pricing POC"
          style={{ width: "100%" }}
        />
      </div>
    </ColumnFilterWrapper>
  );
}

